import "core-js/modules/es.function.name.js";
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Card from 'components/Card';
import Modal from 'components/Modal';
import UserBadgeImage from 'components/UserBadgeImage';
import PageTitle from 'components/PageTitle';
import Sparkles from 'components/Sparkles';
import Button from 'components/Button';
import Panel from 'components/Panel';
import { ModalCloseButton } from 'components/ModalHeadline';
function PlaylistCompletionModal(_ref) {
  var playlist = _ref.playlist,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _ref2 = playlist || {},
    badge = _ref2.badge;
  var hasBadge = (badge === null || badge === void 0 ? void 0 : badge.id) && !(badge !== null && badge !== void 0 && badge.isDeleted);
  var titleId = 'playlist-completion';
  var title = t('title_congratulations');
  var message = hasBadge ? /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_playlist_completion_message_with_badge",
    values: {
      name: playlist === null || playlist === void 0 ? void 0 : playlist.name
    }
  }, "Playlist completed, you have unlocked the", /*#__PURE__*/React.createElement("strong", null, "\"", playlist === null || playlist === void 0 ? void 0 : playlist.name, "\""), " badge!") : /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_playlist_completion_message_no_badge",
    values: {
      name: playlist === null || playlist === void 0 ? void 0 : playlist.name
    }
  }, "You have completed the ", /*#__PURE__*/React.createElement("strong", null, "\"", playlist === null || playlist === void 0 ? void 0 : playlist.name, "\""), " playlist!");
  var pageTitle = hasBadge ? /*#__PURE__*/React.createElement(PageTitle, {
    id: titleId
  }, title) : /*#__PURE__*/React.createElement(Sparkles, null, /*#__PURE__*/React.createElement(PageTitle, {
    id: titleId
  }, title));
  return /*#__PURE__*/React.createElement(Modal, {
    id: "".concat(titleId, "-modal"),
    "aria-labelledby": titleId,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised"
  }, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(ModalCloseButton, {
    onClick: onClose
  })), hasBadge && /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Sparkles, null, /*#__PURE__*/React.createElement(UserBadgeImage, {
    badge: badge,
    hasUserBadge: true,
    size: 100
  }))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, pageTitle), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, message), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: onClose
  }, t('actions_close')))));
}
export default PlaylistCompletionModal;